"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/internal_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalShippingService = void 0;
const internal_service_pb_1 = require("./internal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.shipping.v1.InternalShippingService
 */
exports.InternalShippingService = {
    typeName: "spwn.shipping.v1.InternalShippingService",
    methods: {
        /**
         * @generated from rpc spwn.shipping.v1.InternalShippingService.GetFulfillmentByOrderId
         */
        getFulfillmentByOrderId: {
            name: "GetFulfillmentByOrderId",
            I: internal_service_pb_1.InternalShippingServiceGetFulfillmentByOrderIdRequest,
            O: internal_service_pb_1.InternalShippingServiceGetFulfillmentByOrderIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.shipping.v1.InternalShippingService.GetAllFulfillmentsByOrderIds
         */
        getAllFulfillmentsByOrderIds: {
            name: "GetAllFulfillmentsByOrderIds",
            I: internal_service_pb_1.InternalShippingServiceGetAllFulfillmentsByOrderIdsRequest,
            O: internal_service_pb_1.InternalShippingServiceGetAllFulfillmentsByOrderIdsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 発送をリクエストする
         *
         * @generated from rpc spwn.shipping.v1.InternalShippingService.RequestShipping
         */
        requestShipping: {
            name: "RequestShipping",
            I: internal_service_pb_1.InternalShippingServiceRequestShippingRequest,
            O: internal_service_pb_1.InternalShippingServiceRequestShippingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=internal_service_connect.js.map